import React, { useState } from 'react';
import { Feedback } from '../../Feedback';
import { RemainingTime } from '../../RemainingTime';
import { AdsCounter } from '../../AdsCounter';
import { SkipAdButton } from '../../SkipAdButton';
import { HideableContainer } from '../../HideableContainer';
import { FullscreenButton } from '../../FullscreenButton';
import { Volume } from '../../Volume';
import { ProgressBarContainer, ProgressBar, FlexContainer } from '../styled';
import { ClickThrough } from '../../ClickThrough';
import { Center, Footer, FooterButtons, Container } from '../components';
import { AdvertisementPermanent, AdvertisementPermanentContainer, AdvertisementTimeline, Header, } from './styled';
export const AdvertisementUI = ({ playerInstance }) => {
    const [isHidden, setIsHidden] = useState(false);
    return (React.createElement("div", null,
        React.createElement(AdvertisementPermanent, { isHidden },
            React.createElement(Container, null,
                React.createElement(Header, null),
                React.createElement(Center, null,
                    React.createElement(Feedback, { playerInstance })),
                React.createElement(Footer, null,
                    React.createElement(AdvertisementPermanentContainer, { isHidden },
                        React.createElement(FlexContainer, null,
                            React.createElement(AdsCounter, { playerInstance }),
                            React.createElement(RemainingTime, { playerInstance, showHours: false, formatString: (string) => `(${string})` })),
                        React.createElement(SkipAdButton, { playerInstance }))))),
        React.createElement(HideableContainer, { onShow: () => {
                setIsHidden(false);
            }, onHide: () => {
                setIsHidden(true);
            } },
            React.createElement(Container, null,
                React.createElement(Header, null,
                    React.createElement(ClickThrough, { playerInstance })),
                React.createElement(Center, null),
                React.createElement(Footer, null,
                    React.createElement(ProgressBarContainer, null,
                        React.createElement(ProgressBar, null,
                            React.createElement(AdvertisementTimeline, { playerInstance }))),
                    React.createElement(FooterButtons, null,
                        React.createElement("div", null,
                            React.createElement(Volume, { playerInstance })),
                        React.createElement("div", null,
                            React.createElement(FullscreenButton, { playerInstance }))))))));
};
//# sourceMappingURL=index.js.map